// removed by extract-text-webpack-plugin
module.exports = {"StartChattingButtonWrapper":"StartChattingButtonWrapper__1ZDae","StartChattingButton":"StartChattingButton__I2tfO","StartChattingText":"StartChattingText__17RJc","Header":"Header__2OHXa"};


//////////////////
// WEBPACK FOOTER
// ./routes/OfflineFormular/style.scss
// module id = 3MPn
// module chunks = 0